import React from 'react';

// Import direct des SVG (à adapter selon votre bundler)
import ChevronDownIcon from '@/assets/icons/chevron-down.svg?react';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg?react';
import ArrowLeftIcon from '@/assets/icons/arrow-left.svg?react';
import PushpinDownIcon from '@/assets/icons/pushpin-down.svg?react';
import AddBoxIcon from '@/assets/icons/add-box.svg?react';

export const availablePictos = {
  chevronDown: ChevronDownIcon,
  arrowRight: ArrowRightIcon,
  arrowLeft: ArrowLeftIcon,
  pushpinDown: PushpinDownIcon,
  addBox: AddBoxIcon,
} as const;

export type PictoName = keyof typeof availablePictos;

interface PictoProps extends React.SVGProps<SVGSVGElement> {
  icon: PictoName;
  width?: number;
  height?: number;
  className?: string;
}

function Picto({ icon, ...props }: PictoProps) {
  const IconComponent = availablePictos[icon];

  if (!IconComponent) {
    console.error(`Picto "${icon}" not found`);
    return null;
  }

  try {
    return React.createElement(IconComponent, props);
  } catch (error) {
    console.error(`Error rendering picto "${icon}":`, error);
    return null;
  }
}

export default Picto;
